import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-tank-gauge-helper-dialog",
  templateUrl: "./tank-gauge-helper-dialog.component.html",
  styleUrls: ["./tank-gauge-helper-dialog.component.scss"],
})
export class TankGaugeHelperDialogComponent {
  jsonExample = {
    "tankProbes": [
      {
        "tankProbeID": "1",
        "tankNo": 1,
        "tankName": "TankA-Probe1",
        "productNo": 123,
        "productName": "",
        "manualMode": "true",
        "shellCapacity": "10000",
        "maxSafeFillCap": "10000",
        "lowCapacity": "10",
        "minOperatingCapacity": "1",
        "tankManifoldPartners": [],
        "setPoint": { "hiHiLevel": 99999, "hiLevel": 99999, "loLevel": 0, "loLoLevel": 0, "hiWater": 50000 },
      },
    ],
  };

  constructor(public dialogRef: MatDialogRef<TankGaugeHelperDialogComponent>) {}

  closeDialog() {
    this.dialogRef.close();
  }
}
